import React, { Component } from 'react';
import { connect } from 'react-redux';
import { frontEndUserActions } from 'redux/actions/front-end-action';
import SimpleReactValidator from 'simple-react-validator';
import Address from '../ThemeComponents/Address';

class SignupPage extends Component {
    constructor(props) {
        super(props);
        this.validatorCustomer = new SimpleReactValidator();
        this.state = {
            customer: {
                email: '',
                userName: '',
                password: '',
                confirmPassword: '',
                firstName: '',
                lastName: '',
                company: '',
                // zip_postal: '',
                // stateId: '',
                address: {
                    street_address_1: '',
                    state_id: '',
                    country_id: '',
                    city: '',
                    zipcode: '',
                }
            },
            states: [],
            submitted: false,
        }
        this.onChange = this.onChange.bind(this);
        this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.getChildState = this.getChildState.bind(this);
    }

    onChange(e) {
        this.setState({
            customer: {
                ...this.state.customer,
                [e.target.name]: e.target.value
            }
        });
    }

    getState = (state) => {
        this.setState(prevState => ({
            customer: {
                ...prevState.customer,
                ...state
            }
        }))
    }

    handleCustomerSubmit(e) {
        e.preventDefault();
        // console.log('after validation');
        // this.setState({
        //     submitted: true
        // });
        // const { customer } = this.state;
        // console.log('the custoemr', customer);
        // console.log('the STATE', this.state);

        if (this.validatorCustomer.allValid()) {
            console.log('after validation');
            this.setState({
                submitted: true
            });
            const { customer } = this.state;
            console.log('the custoemr', customer);
            console.log('the STATE', this.state);
        } else {
            this.setState({ submitted: false });
            this.validatorCustomer.showMessages();
            this.forceUpdate();
        }
    }

    handleChangeDropdown(selectedOption, info) {
        if (info.name === 'state') {
            console.log('state select menu', selectedOption);
            this.setState({
                customer: {
                    ...this.state.customer,
                    stateId: selectedOption.value
                }
            })
        }
        if (info.name === 'country') {
            this.setState({
                customer: {
                    ...this.state.customer,
                    countryId: selectedOption.value
                }
            }, () => {
                let updatedStates = [];
                this.props.states.forEach(state => {
                    if (state.countryId === this.state.customer.countryId)
                        updatedStates.push(state);
                });
                this.setState({
                    ...this.state.customer,
                    states: updatedStates
                })
            });
        }
    }

    getChildState(childData) {
        console.log('THE CHILD DATA', childData);
        console.log('the city', childData.city);
        this.setState({
            addressObj: childData
        }, () => {
            console.log('the child state data', this.state.addressObj);
        });

    }

    render() {
        // console.log('the data from state', this.state.addressObj);
        const { email, userName, password, confirmPassword, firstName, lastName, company } = this.state.customer;
        return (
            <div className="container">
                <h2 style={{ textAlign: 'center' }}>New Customer</h2>
                <form onSubmit={this.handleCustomerSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="email">Email<span className="requiredClass">*</span></label>
                                <input type="text" name="email" className="form-control" value={email} onChange={this.onChange} />
                                {this.validatorCustomer.message('email', email, 'required')}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="userName">Username<span className="requiredClass">*</span></label>
                                <input type="text" name="userName" className="form-control" value={userName} onChange={this.onChange} />
                                {this.validatorCustomer.message('Username', userName, 'required')}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="password">Password<span className="requiredClass">*</span></label>
                                <input type="text" name="password" className="form-control" value={password} onChange={this.onChange} />
                                {this.validatorCustomer.message('password', password, 'required')}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="confirmPassword">Confirm Password<span className="requiredClass">*</span></label>
                                <input type="text" name="confirmPassword" className="form-control" value={confirmPassword} onChange={this.onChange} />
                                {this.validatorCustomer.message('confirmPassword', confirmPassword, 'required')}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="firstName">First Name<span className="requiredClass">*</span></label>
                                <input type="text" name="firstName" className="form-control" value={firstName} onChange={this.onChange} />
                                {this.validatorCustomer.message('firstName', firstName, 'required')}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="lastName">Last Name</label>
                                <input type="text" name="lastName" className="form-control" value={lastName} onChange={this.onChange} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className='form-group'>
                                <label htmlFor="company">Company<span className="requiredClass">*</span></label>
                                <input type="text" name="company" className="form-control" value={company} onChange={this.onChange} />
                                {this.validatorCustomer.message('company', company, 'required')}
                            </div>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="col-md-12">
                            <div className='form-group'>
                                <label htmlFor="address_line_1">Address Line 1<span className="requiredClass">*</span></label>
                                <input type="text" name="address_line_1" className="form-control" value={address_line_1} onChange={this.onChange} />
                                {this.validatorCustomer.message('Address line 1', address_line_1, 'required')}
                            </div>
                        </div>
                    </div> */}


                    {/* <div className="row">
                        <div className="col-md-12">
                            <div className='form-group'>
                                <label htmlFor="city">City<span className="requiredClass">*</span></label>
                                <input type="text" name="city" className="form-control" value={city} onChange={this.onChange} />
                                {this.validatorCustomer.message('city', city, 'required')}
                            </div>
                        </div>
                    </div> */}

                    {/* <div className="row">
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="name">Select State<span className="requiredClass">*</span></label>
                                <Select
                                    value={HF.returnLabelWithValue(this.state.customer.stateId, this.state.states)}
                                    onChange={this.handleChangeDropdown}
                                    options={this.state.states}
                                    isSearchable={true}
                                    isMulti={false}
                                    name='state'
                                    placeholder={'Select State'}
                                    isClearable={false}
                                />
                                {this.validatorCustomer.message('state', this.state.states, 'required')}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label htmlFor="zipPostal">Zip / Postal<span className="requiredClass">*</span></label>
                                <input type="text" name="zip_postal" className="form-control" value={zip_postal} onChange={this.onChange} />
                                {this.validatorCustomer.message('zip/postal', zip_postal, 'required')}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className='form-group'>
                                <label htmlFor="name">Select Country<span className="requiredClass">*</span></label>
                                <Select
                                    value={HF.returnLabelWithValue(this.state.customer.countryId, this.props.countries)}
                                    onChange={this.handleChangeDropdown}
                                    options={this.props.countries}
                                    isSearchable={true}
                                    isMulti={false}
                                    name='country'
                                    placeholder={'Select Country'}
                                    isClearable={false}
                                />
                                {this.validatorCustomer.message('country', this.state.customer.countryId, 'required')}
                            </div>
                        </div>
                    </div> */}

                    <hr />
                    <h1>Address Form</h1>
                    <Address
                        addressObject={this.state.customer.address}
                        htmlElement={'customer'}
                        shippingAddress={false}
                        options={
                            {
                                'countries': this.props.countries
                            }
                        }
                        requiredField={
                            {
                                // 'selected_contact': 'required',
                                'contact_name': 'required',
                                'street_address_1': 'required',
                                'country_id': 'required',
                                'city': 'required',
                                'state_id': 'required',
                                'zipcode': '' ? ['integer', 'required'] : ['integer'],
                                phone: 'required',
                                email: 'required',
                            }
                        }
                        getChildState={this.getChildState}
                        returnState={this.getState}
                        validatorInstance={this.validatorCustomer}
                    />


                    <input
                        type="submit"
                        value="Add Customer"
                        className="btn btn-block customBtn"
                    />
                </form>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { loading, frontEndUser, loggedIn } = state.frontEndUserReducer;
    const { countries } = state.countryReducer;
    const { states } = state.stateReducer;
    return {
        countries, states, loading, frontEndUser, loggedIn
    };
}

const mapDispatchToProps = dispatch => {
    return {
        loginCall: (email, password) => { dispatch(frontEndUserActions.login(email, password)) },
        logoutCall: () => { dispatch(frontEndUserActions.logout()) }
    }
}

const Signup = connect(mapStateToProps, mapDispatchToProps)(SignupPage);
export default Signup;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Signup.jsx